export default __webpack_public_path__ + "static/media/ic-share.0412e760.svg";